<div class="col-lg-12 col-md-12 col-sm-12 card" [ngClass]="{'dark-mode': darkMode}">
  <div class="card-header border-header">
    <h3 class="d-inline-block" translate>user.photobox</h3>
    <!-- <button type="button" class="btn btn-info btn-image-add" (click)="sendNewBackgrounds()">Add Backgrounds</button> -->
  </div>
  <div
    *ngIf="currentUser.role.name === 'root' || currentUser.role.name === 'customer' || currentUser.role.name === 'client'"
    class="form-group">
    <!-- search -->
    <div #searchContainer [ngClass]="{'active' : showMyContainer}" class="div select-bg search-container"
      style="display: block;">
      <input type="text" readonly class="search"
        style="height: 44px; display: block; width: 100%; padding-left: 12px;"
        (click)="openDropdown()" name="selectedBackground" [(ngModel)]="selectedBackground">

      <div class="prikaz" *ngIf="showMyContainer">
        <div class="backdrop" (click)="openDropdown()"></div>
        <div style="z-index: 100; overflow-y: auto;">
          <div class="divider"></div>
          <input type="text" class="search-marke" (input)="applyBackgroundFilter()"
            [attr.placeholder]="'user.search' | translate" name="searchBgParam" name="searchBgParam"
            [(ngModel)]="searchBgParam">
          <ul style="margin-bottom: 12px;">
            <li *ngFor="let background of backgroundSearch"
              (click)="addBackground(background.id)">
              {{ background.name }}
              <ng-container *ngFor="let bg of background.backgroundFiles">
                <div class="position-relative" *ngIf="(bg.parameter === 'preview')">
                  <div class="bg-all-files" [style.background-image]="'url(' + bg.fileInfo.thumbnailPath + ')'"></div>
                </div>
              </ng-container>
            </li>
          </ul>
        </div>

      </div>
    </div>
  </div>

  <!-- <ul>
    <li *ngFor="let bg of selectedBackgrounds">
      {{bg.name}}
      <button class="btn button-x" (click)="removeItem(bg.id)">x</button>
    </li>
  </ul> -->
  <hr>
  <div class="row">
    <div class="col-lg-3 col-sm-6" *ngFor="let background of newBackgrounds | slice: (backgroundPage-1) * backgroundPerPage : (backgroundPage-1) * backgroundPerPage + backgroundPerPage">
      <div class="root-application-bg-container ">
        <div class="root-application-image-delete"
          *ngIf="currentUser.role.name === 'root' || currentUser.role.name === 'customer' || currentUser.role.name === 'client'"
          (click)="showDialogDeleteBg(dialogDeleteBg, background)"></div>
        <div class="widget-user-header bg-info-active">
          <h5 class="widget-user-username">{{background?.name}}</h5>
          <hr>
          <div class="row container-bg">
            <ng-container *ngFor="let bg of background.backgroundFiles">
              <div class="position-relative" *ngIf="(bg.parameter === 'preview')">
                <div class="bg-files bg-image" [style.background-image]="'url(' + bg.fileInfo.thumbnailPath + ')'"></div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="clearfix w-100"></div>
    <ngb-pagination *ngIf="newBackgrounds && newBackgrounds.length>8" [collectionSize]="newBackgrounds.length"
      [(pageSize)]="backgroundPerPage" [(page)]="backgroundPage" [maxSize]="5" [rotate]="true"
      (pageChange)="jumpToBackgroundPage($event)"></ngb-pagination>
</div>

<!-- delete bg -->

<ng-template #dialogDeleteBg let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Attempt to delete the file!</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <p>Are you sure you want to delete the file?</p>
      <!-- <div class="image-delete-thumb" [style.background-image]="'url(' + fileToDelete?.fileInfo.path + ')'"></div> -->
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark btn-yes"
      (click)="deleteBackground()">YES</button>
    <button type="button" class="btn btn-outline-dark btn-no" (click)="c('No click')">NO</button>
  </div>
</ng-template>
